import { RosterRequestStatus } from '../generated/graphql';

/**
 * Status color mapping for consistent styling across the application.
 * These colors match the Tailwind CSS color palette and are used in both
 * the Badge component and the status filter dropdown.
 */

export type StatusColorScheme = {
  background: string;
  text: string;
  hover: string;
};

/**
 * Maps request statuses to their corresponding color schemes.
 * Colors are based on Tailwind CSS color palette for consistency.
 */
export const STATUS_COLOR_MAP: Record<RosterRequestStatus, StatusColorScheme> =
  {
    [RosterRequestStatus.RequestReceived]: {
      background: '#f3f4f6',
      text: '#1f2937',
      hover: '#e5e7eb',
    },
    [RosterRequestStatus.InProgress]: {
      background: '#dbeafe',
      text: '#1e40af',
      hover: '#bfdbfe',
    },
    [RosterRequestStatus.CancellationRequested]: {
      background: '#fef3c7',
      text: '#92400e',
      hover: '#fde68a',
    },
    [RosterRequestStatus.AwaitingConfirmation]: {
      background: '#dbeafe',
      text: '#1e40af',
      hover: '#bfdbfe',
    },
    [RosterRequestStatus.MoreInfoRequired]: {
      background: '#fef3c7',
      text: '#92400e',
      hover: '#fde68a',
    },
    [RosterRequestStatus.OverPdApprovalNeeded]: {
      background: '#fef3c7',
      text: '#92400e',
      hover: '#fde68a',
    },
    [RosterRequestStatus.Confirmed]: {
      background: '#d1fae5',
      text: '#065f46',
      hover: '#a7f3d0',
    },
    [RosterRequestStatus.Canceled]: {
      background: '#fee2e2',
      text: '#991b1b',
      hover: '#fecaca',
    },
  };

/**
 * Default color scheme for unknown statuses
 */
export const DEFAULT_STATUS_COLOR_SCHEME: StatusColorScheme = {
  background: '#f5f5f5',
  text: '#333333',
  hover: '#e0e0e0',
};
